// @core/api/endpoints/calendar/update_recurring_event.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EventResponse,
  UpdateRecurringEventRequest,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Update recurring event
 * Updates a recurring event instance or series. Scope controls whether to update this instance only, this and all following, or all instances in the series.
 */
export async function UpdateRecurringEvent(
  event_id: string,
  data: UpdateRecurringEventRequest,
  options?: RequestOptions
): Promise<EventResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/events/:event_id/recurring`;
  requestPath = requestPath.replace(':event_id', encodeURIComponent(event_id));
  const requestOptions = options;
  return client.put<EventResponse>(requestPath, data, requestOptions);
}
